import {
    commonReducer,
    initialCommonState,
    type commonState,
    type commonAction,
} from "./common.reducer";

export interface resourceState<T, F> extends commonState {
    data: T[];
    count: number;
    currentPage: number;
    filters: F;
}

type resourceAction<T, F> =
    | commonAction
    | { type: "SET_DATA"; payload: { results: T[]; count: number } }
    | { type: "SET_PAGE"; payload: number }
    | { type: "SET_FILTERS"; payload: Partial<F> };

export const createInitialResourceState = <T, F>(
    defaultFilters: F,
): resourceState<T, F> => ({
    ...initialCommonState,
    isLoading: true,
    data: [],
    count: 0,
    currentPage: 1,
    filters: defaultFilters,
});

export const createResourceReducer = <T, F>() => {
    return (
        state: resourceState<T, F>,
        action: resourceAction<T, F>,
    ): resourceState<T, F> => {
        const commonState = commonReducer(state, action as commonAction);
        const baseState = {
            ...state,
            ...commonState,
        };

        switch (action.type) {
            case "SET_DATA":
                return {
                    ...baseState,
                    data: action.payload.results,
                    count: action.payload.count,
                };
            case "SET_PAGE":
                return { ...baseState, currentPage: action.payload };
            case "SET_FILTERS":
                return {
                    ...baseState,
                    filters: { ...state.filters, ...action.payload },
                    currentPage: 1,
                };
            default:
                return baseState;
        }
    };
};
